export const MOVE_MARKERS_OPEN_MODAL = 'MOVE_MARKERS_OPEN_MODAL';
export const MOVE_MARKERS_CLOSE_MODAL = 'MOVE_MARKERS_CLOSE_MODAL';
export const MOVE_MARKERS_ACTIVATE = 'MOVE_MARKERS_ACTIVATE';
export const MOVE_MARKERS_DEACTIVATE = 'MOVE_MARKERS_DEACTIVATE';
export const MOVE_MARKERS_DISCARD_CHANGES = 'MOVE_MARKERS_DISCARD_CHANGES';
export const MOVE_MARKERS_UPDATE_MARKER_POSITION = 'MOVE_MARKERS_UPDATE_MARKER_POSITION';
export const MOVE_MARKERS_DRAG_START = 'MOVE_MARKERS_DRAG_START';
export const MOVE_MARKERS_DRAG_STOP = 'MOVE_MARKERS_DRAG_STOP';
